export default __webpack_public_path__ + "static/media/invoice-icon.9c8c8cbd.svg";